import { createApp } from "vue";
import update from "./update.vue";

export default () => {
  const div = document.createElement("div");
  document.body.append(div);
  createApp(update).mount(div);
};
